<div class="app-content" [ngStyle]="instanceBg$ | async">
  <router-outlet></router-outlet>
</div>
